module.exports = __webpack_public_path__ + "images/icons/white-checkmark-6d87fb4b.svg";